import * as locationsActions from './actions';
import locationsReducer from './reducer';
import * as locationsTypes from './types';
import * as locationsUtils from './utils';

export {locationsActions, locationsTypes, locationsUtils};

export default locationsReducer;
